import React from 'react';
import { OLI_AI_ICON, OLI_AI_ICON_WHITE } from '@/lib/branding';

type OliBrandIconProps = {
  className?: string;
  variant?: 'color' | 'white';
};

export default function OliBrandIcon({ className, variant = 'color' }: OliBrandIconProps) {
  return (
    <img
      src={variant === 'white' ? OLI_AI_ICON_WHITE : OLI_AI_ICON}
      alt="Oli AI"
      className={className}
    />
  );
}